<template lang='pug'>
  .container
    .container
      .row.mt-5.align-items-center
        .col-12.my-header.font-weight-bold
            | Результаты опроса
    .container.mt-5(v-if="loading")
      object(type="image/svg+xml" data="/assets/loaders/infinity.svg")
    .container.mt-5(v-if="!loading")
      .white_block.feedback(v-for="feedback in feedbacks")
        .name {{feedback.info.data.name}}
        .phone {{feedback.info.data.phone}}
        .spent Потратил {{feedback.info.data.spent}} руб.
        .visited Дата закрытия чека: {{feedback.info.data.closedAt}}
        .questions
          .question(v-for="result in feedback.results")
            .title {{result.title}}
            .answer {{result.answer}}       

</template>
<script>
var apiDriver = require("../../apiDriver").default;

export default {
  data() {
    return {
      feedbacks: [],
      loading: true
    };
  },

  computed: {},

  mounted() {
    this.loadResults();
  },

  methods: {
    async loadResults(){
      let r = await apiDriver.services.api.get("sms_feedback", 'getFeedbacks');
      let feedbacks = r.data;
      for(let feedback of feedbacks){
        feedback.results = [];
        let q_keys = Object.keys(feedback.data.data);
        for(let q_key of q_keys) {
          let answer = feedback.data.data[q_key];
          if(Array.isArray(answer)) answer = answer.join(", ") + ".";
          feedback.results.push({title: feedback.data.dict[q_key], answer});
        }
        console.log("feedback.results", feedback.results);
      }
      this.feedbacks = feedbacks;
      this.loading = false;
      console.log("feedbacks:", feedbacks);
    }
  }
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 26pt;
}

.header-sub {
  // color: white;
  font-size: 1.5rem;
}

button.styled, a.styled {
  margin-bottom: 5px;
  border: 1px solid #6c68cb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #464384;
  cursor: pointer;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  &[disabled] {
    border-color: #ddd;
    color: #ddd;
    cursor: default;
    background: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
